import React, { useContext, useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useAxios from "../../../hooks/useAxios";
import "./TeacherDashboardPage.css";
import {
  Box,
  CircularProgress,
  Container,
  Typography,
  Button,
  Grid,
  Tooltip,
} from "@mui/material";
import Header from "../../../components/Header/Header";
import ContentHeader from "../../../components/common/ContentHeader/ContentHeader";
import ClassCard from "../../../components/QuizComponents/Cards/ClassCard/ClassCard";
import CreateClassModal from "../../../components/DashboardComponents/Modals/CreateClassModal/CreateClassModal";
import QuizManagementTable from "../../../components/DashboardComponents/StudentDashboard/QuizManagementTable/QuizManagementTable";
import { useNavigate } from "react-router-dom";
import ReportCard from "../../../components/Reporting/Cards/ReportCard";
import AssessmentIcon from '@mui/icons-material/Assessment';
import GroupIcon from '@mui/icons-material/Group';
import { AuthContext } from "../../../context/AuthContext";

const navLinks = [
];

function TeacherDashboardPage() {
  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const { setStatus } = useContext(AuthContext);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, etError] = useState(null);
  const [isCreateClassModalOpen, setIsCreateClassModalOpen] = useState(false);

  const handleOpenCreateClassModal = () => setIsCreateClassModalOpen(true);
  const handleCloseCreateClassModal = () => {
    setIsCreateClassModalOpen(false);
    fetchClasses();
  };

  const fetchClasses = async () => {
    try {
      const response = await axiosInstance.get("/classes");
      if (response.data.success) {
        setClasses(response.data.classes);
        setStatus(response.data.user.status);
      } else {
        toast.error(response.data.message || "Failed to fetch classes.");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchClasses();
  }, []);

  const handleClassClick = (classId) => {
    navigate(`/classes/${classId}`);
  };

  const handleCreateQuiz = () => {
    navigate("/quiz/create");
  };

  let content;
  if (loading) {
    content = (
      <Box className="loading-container">
        <CircularProgress />
        <Typography variant="h6" className="loading-text">
          Fetching Classes...
        </Typography>
      </Box>
    );
  } else if (error) {
    content = (
      <Box className="error-container">
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      </Box>
    );
  } else {
    content = (
      <>
      {/* Quiz Management Section */}
      <ContentHeader
          title="Quiz Management"
          buttonLabel="Create Quiz"
          onButtonClick={handleCreateQuiz}
        />
        {/* <Box className="quiz-management-info">
          <Typography variant="body1" color="textSecondary">
            Create quizzes globally and attach them to any of your classes. You can also manage which quizzes are active in each class.
          </Typography>
        </Box> */}
        
        {/* Quiz Management Table */}
        <div className="mb-5">
          <QuizManagementTable />
        </div>
        <ContentHeader
          title="Your Classes"
          buttonLabel="Create Class"
          onButtonClick={handleOpenCreateClassModal}
        />
        <Grid container spacing={3} className="classes-grid mb-5">
          {classes.length ? (
            classes.map((classData) => (
              <Grid item xs={12} sm={6} md={4} key={classData.id}>
                <ClassCard
                  classData={classData}
                  onClick={() => handleClassClick(classData.id)}
                />
              </Grid>
            ))
          ) : (
            <Typography className="no-classes">No classes to show</Typography>
          )}
        </Grid>

        

        {/* Reporting Section */}
        <ContentHeader
            title="Reporting"
        />
        <div className="reports-grid">
            {/* Active Sessions Report Card */}
            <ReportCard
                icon={AssessmentIcon}
                title="Active Sessions"
                description="Monitor all active sessions of students currently taking your Assessments. Stay updated with their real-time progress and performance."
                buttonLabel="View Active Sessions"
                onButtonClick={() => navigate('/reporting/active-sessions', { state: { enableClassFilter: true } })}
                />
            {/* Attempted Users Report Card */}
            <ReportCard
                icon={GroupIcon}
                title="Attempted Users"
                description="View comprehensive reports of all students who have attempted your Assessments. Analyze their performance and insights."
                buttonLabel="View Attempted Users"
                onButtonClick={() => navigate('/reporting/attempted-users', { state: { enableClassFilter: true } })}
            />
        </div>
      </>
    );
  }

  return (
    <>
      <Header navLinks={navLinks} isScrollEffect={false} />
      <Container className="teacher-dashboard-container page-container">
        {content}
      </Container>
      <CreateClassModal
        open={isCreateClassModalOpen}
        onClose={handleCloseCreateClassModal}
      />
      <ToastContainer />
    </>
  );
}

export default TeacherDashboardPage;
